import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import dayjs from "dayjs";


const ThyroidUltrasoundview = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

  const fetchData = async () => {
    try {
      const response = await axios.post(
        `/v2/ag/v1/${window.getPracticeId()}/imaging/get-image/id`,
   {
  row_id: parseInt(filename, 10),
}

      );

   
      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData); // use parsed API data
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);

  return (
  <div
  className="p-6 bg-white min-h-screen w-full flex justify-center items-center"
  id={examData ? "report-ready" : undefined}
>
  <div className="w-full max-w-3xl flex flex-col items-center border border-gray-300 rounded-md p-4 shadow-sm">
    {/* Header */}
    <div className="flex items-start  w-full justify-center">
      <img
        src={BrianyCareLogo}
        alt="C-HIM Logo"
        className="w-14 h-14 mr-3"
      />
      <div>
        <h1 className="text-xl font-bold text-start text-blue-600 leading-none">
          C-HIM
        </h1>
        <p className="text-sm font-semibold mt-1">
          Center for Hypertension & Internal Medicine
        </p>
      </div>
    </div>

    {/* Title */}
    <h2 className="text-center font-bold text-base underline mb-4">
      THYROID ULTRASOUND
    </h2>

    {/* Patient Info */}
    {examData ? (
      <>
        <div className="flex justify-start text-sm text-left w-full mb-4">
  <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
    <span><strong>MR No#</strong></span>
    <span>:</span>
    <span>{examData.patient_id}</span>

    <span><strong>Name</strong></span>
    <span>:</span>
    <span>{examData.pat_name}</span>

    <span><strong>Age</strong></span>
    <span>:</span>
    <span>{examData.pat_age}</span>

    <span><strong>Exam Date</strong></span>
    <span>:</span>
    <span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>

    <span><strong>Date of Birth</strong></span>
    <span>:</span>
    <span>{dayjs(examData.pat_dob).format("MMM D, YYYY")}</span>

    <span><strong>Provider</strong></span>
    <span>:</span>
    <span>{examData.providername}</span>

    <span><strong>Preliminary</strong></span>
    <span>:</span>
    <span>{examData.preliminary}</span>

    <span><strong>Patients History</strong></span>
    <span>:</span>
    <span>{examData.pathistory}</span>
  </div>
</div>


        {/* Thyroid Image with Tags */}
        <div className="relative w-full max-h-[300px] mt-6 mb-4">
          <img
            src="/cloud-assets/chim/public//assets/images/ThyroidUltrasound.jpeg?id=20250715"
            alt="Thyroid Diagram"
            className="w-full object-contain border rounded-md cursor-crosshair"
          />

          {/* Render saved tags */}
          {examData.imgtagsArr.map((tag, index) => (
            <div
              key={index}
              className="absolute px-2 py-0.5 bg-red-500 text-white text-xs font-semibold rounded"
              style={{
                left: tag.x,
                top: tag.y,
                transform: "translate(-50%, -100%)",
                pointerEvents: "none",
              }}
            >
              {tag.name}
            </div>
          ))}
        </div>

        {/* Measurements Grid */}
        <div className="text-sm mb-6 grid grid-cols-4 gap-y-2 gap-x-8 w-full">
          {/* Right Lobe */}
          <div>
            <strong>Rt Lobe L:</strong> {examData.rtlobel}
          </div>
          <div>
            <strong>Rt Lobe W:</strong> {examData.rtlobew}
          </div>
          <div>
            <strong>Rt Lobe H:</strong> {examData.rtlobeh}
          </div>
          <div>
            <strong>Rt Units:</strong> {examData.rtlobeunits}
          </div>
          {examData.rtlobeComments && (
            <div className="col-span-4 text-start ml-10">
              <strong>Right Lobe Comments:</strong> {examData.rtlobeComments}
            </div>
          )}

          {/* Left Lobe */}
          <div>
            <strong>Lt Lobe L:</strong> {examData.ltlobel}
          </div>
          <div>
            <strong>Lt Lobe W:</strong> {examData.ltlobew}
          </div>
          <div>
            <strong>Lt Lobe H:</strong> {examData.ltlobeh}
          </div>
          <div>
            <strong>Lt Units:</strong> {examData.ltlobeunits}
          </div>
          {examData.ltlobeComments && (
            <div className="col-span-4 text-start ml-10">
              <strong>Left Lobe Comments:</strong> {examData.ltlobeComments}
            </div>
          )}

          {/* Isthmus */}
          <div>
            <strong>Isthmus:</strong> {examData.ishtmus}{" "}
            {examData.ishtmusunits}
          </div>
          <div></div>
          <div></div>
          <div></div>
          {examData.ishtmusComments && (
            <div className="col-span-4 text-start ml-10">
              <strong>Isthmus Comments:</strong> {examData.ishtmusComments}
            </div>
          )}
        </div>

        {/* Impression */}
        <div className="text-sm text-start w-full mb-6 ml-10">
          <strong>Sonographers Impression:</strong>{" "}
          {examData.sonographersImpression}
        </div>

        {/* Signature */}
      <div className="flex justify-end w-full">
  <div className="relative flex items-stretch border p-2 min-w-[350px] max-w-full">
    
    {/* Signature - grows with content */}
    <div className="font-semibold pr-4 z-10 break-words whitespace-pre-wrap max-w-[50%]">
      {examData.signature}
    </div>

    {/* Divider */}
    <div className="absolute top-0 bottom-0 left-1/2 w-px bg-gray-300" />

    {/* Right section - always left aligned */}
    <div className="text-sm text-left z-10 pl-4 w-1/2">
      <div>Digitally Signed by</div>
    <div>{examData?.createdby||''}</div>
        <div>{dayjs(examData.dateofservice).format("MM-DD-YYYY")}</div>
    </div>
  </div>
</div>

      </>
    ) : (
      <p className="text-center text-gray-500">Loading...</p>
    )}
  </div>
</div>

  );
};

export default ThyroidUltrasoundview;
